module.exports = __webpack_public_path__ + "static/media/banner4-mob.ceb99880.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/banner4-mob.png
// module id = 44
// module chunks = 0